import { render } from "./VenueView.vue?vue&type=template&id=31beaec9&scoped=true"
import script from "./VenueView.vue?vue&type=script&lang=js"
export * from "./VenueView.vue?vue&type=script&lang=js"

import "./VenueView.vue?vue&type=style&index=0&id=31beaec9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31beaec9"]])

export default __exports__